module.exports = __webpack_public_path__ + "static/media/icons-dark-gray-logout.e70c2900.svg";